/* eslint-disable @typescript-eslint/no-explicit-any */
import { createContext, useContext, FC } from 'react';

const StaticDataContext = createContext<any>({});

export const useStaticDataContext = () => {
  return useContext(StaticDataContext);
};

export const StaticDataContextProvider: FC<{ children: JSX.Element | JSX.Element[]; value: any }> = ({
  children,
  value,
}) => {
  return <StaticDataContext.Provider value={value}>{children}</StaticDataContext.Provider>;
};
